import type { ComponentProps } from 'react';
import HomeRaw from '../../../../assets/icons/home.svg?react';
import BreathworksRaw from '../../../../assets/icons/breathworks.svg?react';
import JourneysRaw from '../../../../assets/icons/journeys.svg?react';
import ActivityRaw from '../../../../assets/icons/activity.svg?react';
import AchievementsRaw from '../../../../assets/icons/achievements.svg?react';
import PricingRaw from '../../../../assets/icons/pricing.svg?react';
import ShareRaw from '../../../../assets/icons/share.svg?react';
import EyeRaw from '../../../../assets/icons/eye.svg?react';
import EyeOffRaw from '../../../../assets/icons/eye-off.svg?react';
import GoogleRaw from '../../../../assets/icons/google.svg?react';
import ChevronRightRaw from '../../../../assets/icons/chevron-right.svg?react';
import PencilRaw from '../../../../assets/icons/pencil.svg?react';

export function HomeIcon(props: ComponentProps<typeof HomeRaw>) {
  return <HomeRaw width={18} height={18} aria-hidden="true" {...props} />;
}

export function BreathworksIcon(props: ComponentProps<typeof BreathworksRaw>) {
  return <BreathworksRaw width={18} height={18} aria-hidden="true" {...props} />;
}

export function JourneysIcon(props: ComponentProps<typeof JourneysRaw>) {
  return <JourneysRaw width={18} height={18} aria-hidden="true" {...props} />;
}

export function ActivityIcon(props: ComponentProps<typeof ActivityRaw>) {
  return <ActivityRaw width={18} height={18} aria-hidden="true" {...props} />;
}

export function AchievementsIcon(props: ComponentProps<typeof AchievementsRaw>) {
  return <AchievementsRaw width={18} height={18} aria-hidden="true" {...props} />;
}

export function PricingIcon(props: ComponentProps<typeof PricingRaw>) {
  return <PricingRaw width={18} height={18} aria-hidden="true" {...props} />;
}

export function ShareIcon(props: ComponentProps<typeof ShareRaw>) {
  return <ShareRaw width={16} height={16} aria-hidden="true" {...props} />;
}

export function EyeIcon(props: ComponentProps<typeof EyeRaw>) {
  return <EyeRaw width={18} height={18} aria-hidden="true" {...props} />;
}

export function EyeOffIcon(props: ComponentProps<typeof EyeOffRaw>) {
  return <EyeOffRaw width={18} height={18} aria-hidden="true" {...props} />;
}

export function GoogleIcon(props: ComponentProps<typeof GoogleRaw>) {
  return <GoogleRaw width={18} height={18} aria-hidden="true" {...props} />;
}

export function ChevronRightIcon(props: ComponentProps<typeof ChevronRightRaw>) {
  return <ChevronRightRaw width={14} height={14} aria-hidden="true" {...props} />;
}

export function PencilIcon(props: ComponentProps<typeof PencilRaw>) {
  return <PencilRaw width={13} height={13} aria-hidden="true" {...props} />;
}
